import { ActionCategory, ActionDelay } from "../interfaces/actions";

export enum ActionType {
  ENABLE_VOUCHERS = 'vouchers_enabled',
  ENABLE_MANUAL_VOUCHER_APPROVAL = 'manual_voucher_approval_on',
  ENABLE_REPLACE_EXCHANGE = 'enable_replace_exchange',
  ENABLE_SAME_ITEM_REPLACEMENT = 'enable_same_item_replacement',
  ENABLE_REFUND_REQUIRE_IMAGE = 'refund_require_image',
  ENABLE_CANCEL_ORDER = 'enable_cancel_order',
  ENABLE_CANCEL_APPROVAL = 'enable_cancel_approval',
  ENABLE_PRODUCT_INFORMATION = 'enable_product_info',
  ENABLE_CHANGE_ADDRESS = 'enable_change_address',
  ENABLE_CHANGE_ADDRESS_APPROVAL = 'enable_change_address_approval',
  ENABLE_ORDER_TRACKING = 'enable_order_tracking',
  ENABLE_NO_MEDICAL_ADVICE = 'enable_no_medical_advice',
  ENABLE_RETURN_TRACKING = 'enable_return_tracking',
}

export const ActionCategories: { [key in ActionCategory]: { id: key; name: string } } = {
  ADDRESS_CHANGE: {
    id: 'ADDRESS_CHANGE',
    name: 'Address Change',
  },
  ANSWERING: {
    id: 'ANSWERING',
    name: 'Answering',
  },
  ORDER_CANCEL: {
    id: 'ORDER_CANCEL',
    name: 'Order Cancel',
  },
  ORDER_TRACKING: {
    id: 'ORDER_TRACKING',
    name: 'Order Tracking',
  },
  PRODUCTS: {
    id: 'PRODUCTS',
    name: 'Products',
  },
  RETURNS_REPLACEMENTS_REFUNDS: {
    id: 'RETURNS_REPLACEMENTS_REFUNDS',
    name: 'Returns, Replacements and Refunds',
  },
  NO_CATEGORY: {
    id: 'NO_CATEGORY',
    name: 'No Category',
  },
  RETURN_TRACKING: {
    id: 'RETURN_TRACKING',
    name: 'Return Tracking',
  }
}

export const ACTION_DELAYS: { [key: string]: ActionDelay } = {
  '5_minutes': {
    id: '5_minutes',
    minutes: 5,
    name: '5 Minutes'
  },
  '30_minutes': {
    id: '30_minutes',
    minutes: 30,
    name: '30 Minutes'
  },
  '1_hour': {
    id: '1_hour',
    minutes: 60,
    name: '1 Hour'
  },
  '3_hours': {
    id: '3_hours',
    minutes: 180,
    name: '3 Hours'
  },
  '12_hours': {
    id: '12_hours',
    minutes: 720,
    name: '12 Hours'
  },
  '24_hours': {
    id: '24_hours',
    minutes: 1440,
    name: '24 Hours'
  }
};

export const RESPONSE_DELAYS: { [key: string]: ActionDelay } = {
  '5_minutes': {
    id: '5_minutes',
    minutes: 5,
    name: '5 Minutes'
  },
  '30_minutes': {
    id: '30_minutes',
    minutes: 30,
    name: '30 Minutes'
  },
  '1_hour': {
    id: '1_hour',
    minutes: 60,
    name: '1 Hour'
  },
  '3_hours': {
    id: '3_hours',
    minutes: 180,
    name: '3 Hours'
  },
  '24_hours': {
    id: '24_hours',
    minutes: 1440,
    name: '24 Hours'
  }
};

export const NEW_L2_ACTIONS = {
  'RETURN_TRACKING': {
      'action': 'RETURN_TRACKING',
      'string': '<RETURN_TRACKING>',
      'action_name': 'Return Tracking',
      'action_description': 'Track a return order',
      'action_category': 'ORDER_TRACKING'
  },
  'CHANGE_ORDER': {
      'action': 'CHANGE_ORDER', 
      'string': '<CHANGE_ORDER>',
      'action_name': 'Change Order',
      'action_description': 'Make changes to an existing order',
      'action_category': 'ORDER_MANAGEMENT'
  },
  'CHANGE_ORDER_DATE': {
      'action': 'CHANGE_ORDER_DATE',
      'string': '<CHANGE_ORDER_DATE>',
      'action_name': 'Change Order Date',
      'action_description': 'Change the delivery date of an order',
      'action_category': 'ORDER_MANAGEMENT'
  },
  'FIND_ORDER': {
      'action': 'FIND_ORDER',
      'string': '<FIND_ORDER>',
      'action_name': 'Find Order',
      'action_description': 'Look up order details',
      'action_category': 'ORDER_MANAGEMENT'
  },
  'USE_DISCOUNT_CODE': {
      'action': 'USE_DISCOUNT_CODE',
      'string': '<USE_DISCOUNT_CODE>',
      'action_name': 'Use Discount Code',
      'action_description': 'Apply a discount code to an order',
      'action_category': 'DISCOUNTS'
  },
  'MISSING_ITEMS_REPLACEMENT': {
      'action': 'MISSING_ITEMS_REPLACEMENT',
      'string': '<MISSING_ITEMS_REPLACEMENT>',
      'action_name': 'Missing Items Replacement',
      'action_description': 'Process replacement for missing items',
      'action_category': 'RETURNS_REPLACEMENTS_REFUNDS'
  },
  'WRONG_ITEM': {
      'action': 'WRONG_ITEM',
      'string': '<WRONG_ITEM>',
      'action_name': 'Wrong Item',
      'action_description': 'Handle case of wrong item being sent',
      'action_category': 'RETURNS_REPLACEMENTS_REFUNDS'
  },
  'RESEND_ORDER_CONFIRMATION': {
      'action': 'RESEND_ORDER_CONFIRMATION',
      'string': '<RESEND_ORDER_CONFIRMATION>',
      'action_name': 'Resend Order Confirmation',
      'action_description': 'Resend the order confirmation email',
      'action_category': 'ORDER_MANAGEMENT'
  },
  'RESEND_INVOICE': {
      'action': 'RESEND_INVOICE',
      'string': '<RESEND_INVOICE>',
      'action_name': 'Resend Invoice',
      'action_description': 'Resend the order invoice',
      'action_category': 'ORDER_MANAGEMENT'
  },
  'ORDER_WAS_SENT_BACK_WRONG_ADDRESS': {
      'action': 'ORDER_WAS_SENT_BACK_WRONG_ADDRESS',
      'string': '<ORDER_WAS_SENT_BACK_WRONG_ADDRESS>',
      'action_name': 'Order Sent Back Wrong Address',
      'action_description': 'Handle order returned due to wrong address',
      'action_category': 'ADDRESS_CHANGE'
  },
  'FAILED_DELIVERY': {
        'action': 'FAILED_DELIVERY',
        'string': '<FAILED_DELIVERY>',
        'action_name': 'Failed Delivery',
        'action_description': 'Handle failed delivery',
        'action_category': 'ORDER_TRACKING'
    }
}

export const ACTIONS_TYPES = {
  'CUSTOM_HUMAN_ACTION': {
      'action': 'CUSTOM_HUMAN_ACTION',
      'string': '<CUSTOM_HUMAN_ACTION>',
      'action_name': 'Custom Human Action',
      'action_description': 'None of the above actions can be taken, a human agent needs to take over.',
      'action_category': null
  },
  'ORDER_TRACKING': {
      'action': 'ORDER_TRACKING',
      'string': '<ORDER_TRACKING>',
      'action_name': 'Order Tracking',
      'action_description': 'Track the order',
      'action_category': 'ORDER_TRACKING'
  },
  'REPLACEMENT_REFUND': {
      'action': 'REPLACEMENT_REFUND',
      'string': '<REPLACEMENT_REFUND>',
      'action_name': 'Replacement or refund',
      'action_description': 'Process replacement or a refund',
      'action_category': 'RETURNS_REPLACEMENTS_REFUNDS'
  },
  'CHANGE_ADDRESS': {
      'action': 'CHANGE_ADDRESS',
      'string': '<CHANGE_ADDRESS>',
      'action_name': 'Change Address',
      'action_description': 'Change the delivery address',
      'action_category': 'ADDRESS_CHANGE'
  },
  'PRODUCT_AVAILABILITY': {
      'action': 'PRODUCT_AVAILABILITY',
      'string': '<PRODUCT_AVAILABILITY>',
      'action_name': 'Product Availability',
      'action_description': 'Check product availability',
      'action_category': 'PRODUCTS'
  },
  'PRODUCT_INFO': {
      'action': 'PRODUCT_INFO',
      'string': '<PRODUCT_INFO>',
      'action_name': 'Product Information',
      'action_description': 'Provide product information',
      'action_category': 'PRODUCTS'
  },
  'CANCEL_ORDER': {
      'action': 'CANCEL_ORDER',
      'string': '<CANCEL_ORDER>',
      'action_name': 'Cancel order',
      'action_description': 'Cancel order that has not been shipped yet',
      'action_category': 'ORDER_CANCEL'
  },
  'POLICY_ANSWER': {
      'action': 'POLICY_ANSWER',
      'string': '<POLICY_ANSWER>',
      'action_name': 'Policy Answer',
      'action_description': 'Answer the question that is related to shop general policies',
      'action_category': 'ANSWERING'
  },
  'SOLVED': {
      'action': 'SOLVED',
      'string': '<SOLVED>',
      'action_name': 'Solved',
      'action_description': 'The ticket is solved, no further actions needs to be taken',
      'action_category': 'ANSWERING'
  },
  'VOUCHER_APPROVAL': {
      'action': 'VOUCHER_APPROVAL',
      'string': '<VOUCHER_APPROVAL>',
      'action_name': 'Voucher approval',
      'action_description': 'Accept voucher approval and create a voucher',
      'action_category': 'RETURNS_REPLACEMENTS_REFUNDS'
  },
  'RETURN_TRACKING': {
      'action': 'RETURN_TRACKING',
      'string': '<RETURN_TRACKING>',
      'action_name': 'Return Tracking',
      'action_description': 'Track a return order',
      'action_category': 'RETURNS_REPLACEMENTS_REFUNDS'
  },
}
